import api from './api'

export const filterService = {
  /**
   * Fetches every active filter
   */
  async getAll() {
    try {
      const response = await api.get('/filters')
      return response.data
    } catch (error) {
      console.error('Erro ao buscar filtros:', error)
      throw error
    }
  },

  /**
   * Fetches filters in a hierarchical structure
   * @param {string} categoryId - Category ID used to filter the counts (optional)
   */
  async getHierarchical(categoryId = null) {
    try {
      const params = categoryId ? { categoryId } : {}
      const response = await api.get('/filters/hierarchical', { params })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar filtros hierárquicos:', error)
      throw error
    }
  },

  /**
   * Fetches filters by category
   */
  async getByCategory(categoryId) {
    try {
      const response = await api.get(`/filters/by-category/${categoryId}`)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar filtros por categoria:', error)
      throw error
    }
  },

  /**
   * Fetches a specific filter by ID
   */
  async getById(id) {
    try {
      const response = await api.get(`/filters/${id}`)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar filtro:', error)
      throw error
    }
  }
}

